var render = function render(){var _vm=this,_c=_vm._self._c;return _c('third-party-login',{attrs:{"title":_vm.$t('login.loginWithSAML'),"links":_vm.links}})
}
var staticRenderFns = []

export { render, staticRenderFns }